@if (recyclabilityStatus) {
  <div class="recyclability-status">
    <span>{{ recyclabilityStatus.foreignName }}</span>
    <img
      class="recyclability-img"
      [ngSrc]="recyclabilityStatus.symbolPath"
      height="65"
      width="65"
      [alt]="recyclabilityStatus.localName"
    />
    <span>{{ recyclabilityStatus.localName }}</span>
  </div>
}
